import { render } from "./payRefund.vue?vue&type=template&id=48fc1529&scoped=true"
import script from "./payRefund.vue?vue&type=script&lang=js"
export * from "./payRefund.vue?vue&type=script&lang=js"

import "./payRefund.vue?vue&type=style&index=0&id=48fc1529&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48fc1529"]])

export default __exports__